import { topicTiles } from "@/mocks/headlines";

export default function TopicsSection() {
  return (
    <section id="topics" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-10 md:px-6 md:py-14">
      <div className="mb-2 flex items-center gap-2">
        <span className="h-5 w-1 bg-primary-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">专题合集 · 目录索引</h2>
      </div>
      <p className="mb-6 text-xs text-foreground-600 md:text-sm">
        按事件类型归档的合集。想横向对比、按时间深挖，从这里整册读起最省力。
      </p>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {topicTiles.map((t, i) => (
          <a
            key={t.title}
            href="#top"
            className="group flex flex-col overflow-hidden border border-background-200 bg-background-50 transition-colors hover:border-background-300"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src={t.cover}
                alt={t.title}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded-sm bg-background-50/90 px-1.5 py-0.5 text-[11px] font-semibold text-accent-800 backdrop-blur">
                {t.tag}
              </span>
              <span className="absolute bottom-0 left-0 px-3 py-1 font-heading text-5xl font-black text-background-50/25">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="font-heading text-base font-bold text-foreground-950">{t.title}</h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{t.desc}</p>
              <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs">
                <span className="flex items-center gap-1 font-medium text-foreground-600">
                  <i className="ri-book-open-line text-accent-600" /> {t.count}
                </span>
                <span className="flex items-center gap-1 font-semibold whitespace-nowrap text-primary-600">
                  进入合集 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}